export default __webpack_public_path__ + "static/media/receipt-icon.61f28812.svg";